import { message } from "antd";
import { element } from "prop-types";
import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Card, CardBody, CardTitle } from "reactstrap";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";
import { subscriptionSave } from "../../../service/user-detail-service";
import RakBeneficiariesTab from "./tabs/rakbeneficiarytab";
import C3beneficiarytab from "./tabs/c3beneficiarytab";
import C3transactiontab from "./tabs/c3transactiontab";
import RakTransactionsTab from "./tabs/raktransactionstab";
import RechargeBeneficiariesTab from "./tabs/rechargebeneficiarytab";
import RechargeTransactionsTab from "./tabs/rechargeTransactionstab";
import SubscriptionsTab from "./tabs/subscribtiontab";
import Billerstab from "./tabs/billers";
import BillPayments from "./tabs/billPayments";

const VasServicesTab = ({ userId, allUsersObject }) => {
  const [buttonloader, setbuttonloader] = useState(false);
  console.log(userId);
  const [id, setId] = useState();
  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, [id]);

  const subscriptionSaveClicked = async (data) => {
    let subscribes = await [];
    let unSubscribes = await [];
    if (data && data.length > 0) {
      await data.forEach((element) => {
        if (element.isActive) {
          subscribes.push(element.id);
        } else {
          unSubscribes.push(element.id);
        }
      });
    }
    let request = await {
      subscribes,
      unSubscribes,
    };
    setbuttonloader(true);
    await subscriptionSave(id, request)
      .then((subscriptionSaveRes) => {
        setbuttonloader(false);
        // message.success("Saved successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Saved successfully"
        );
      })
      .catch((subscriptionSaveErr) => {
        setbuttonloader(false);
        // message.error("Something went wrong");
        console.log(subscriptionSaveErr);
      });
  };

  return (
    <>
      <Card style={{ marginBottom: "10px" }}>
        <CardBody style={{ paddingTop: 20, paddingBottom: 20 }}>
          <CardTitle
            className="mb-3"
            tag="h1"
            style={{ paddingTop: 15, paddingBottom: 20 }}
            className="user-verification-header"
          >
            Vas Services
          </CardTitle>
          <Tabs>
            <TabList style={{ fontFamily: "Montserrat-Medium" }}>
              <Tab>RAK Beneficiaries</Tab>
              <Tab>RAK Transactions</Tab>
              <Tab>Recharge Beneficiaries</Tab>
              <Tab>Recharge Transactions</Tab>
              <Tab>C3 to C3 Beneficiaries</Tab>
              <Tab>C3 to C3 Transactions</Tab>
              <Tab>Subscriptions</Tab>
              <Tab>Billers</Tab>
              <Tab>Bill payments</Tab>
            </TabList>
            <TabPanel>
              <RakBeneficiariesTab userId={id} />
            </TabPanel>
            <TabPanel>
              <RakTransactionsTab userId={id} allUsersObject={allUsersObject} />
            </TabPanel>
            <TabPanel>
              <RechargeBeneficiariesTab userId={id} />
            </TabPanel>
            <TabPanel>
              <RechargeTransactionsTab
                userId={id}
                allUsersObject={allUsersObject}
              />
            </TabPanel>
            <TabPanel>
              <C3beneficiarytab userId={id} />
            </TabPanel>
            <TabPanel>
              <C3transactiontab userId={id} />
            </TabPanel>
            <TabPanel>
              <SubscriptionsTab
                userId={id}
                subscriptionSaveClicked={(data) =>
                  subscriptionSaveClicked(data)
                }
                buttonloader={buttonloader}
              />
            </TabPanel>
            <TabPanel>
              <Billerstab userId={id} />
            </TabPanel>
            <TabPanel>
              <BillPayments userId={id} />
            </TabPanel>
          </Tabs>
        </CardBody>
      </Card>
    </>
  );
};
export default VasServicesTab;
